import { Modal } from "../../common/components/Modal";
import { useRef } from "react";
import { ItemConst } from "../../../constants/ItemConst";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { useIntl } from "react-intl";

export const DetailDialog = ({ itemID, show, onHide }) => {
  const dismissBtnRef = useRef();
  const intl = useIntl();
  // Find the item details using the itemID
  const item = ItemConst.find((item) => item.title === itemID);

  if (!item) return null;

  // Split the details string by newline (\n) and map over the result
  const detailLines = item.details.split("\n");

  return (
    <Modal
      modalId="detailModal"
      title={item.code ? item.code : intl.formatMessage({ id: item.title })}
      show={show}
      onHide={onHide}
      dismissBtnRef={dismissBtnRef}
    >
      <div style={{ textAlign: "center" }}>
        <img
          src={toAbsoluteUrl(item.image)}
          alt={intl.formatMessage({ id: item.title })}
          style={{ width: "70%", objectFit: "cover" }}
        />
        <div style={{ textAlign: "start", padding: "0 5px" }}>
          <h5>{intl.formatMessage({ id: item.title })}</h5>
          {detailLines.map((line, index) => (
            <div key={index} className="my-2">
              {intl.formatMessage({ id: line })}
            </div>
          ))}
          <div>
            {intl.formatMessage({ id: "price" })}: RM {item.price}
          </div>
        </div>
        <button
          onClick={() => dismissBtnRef.current?.click()}
          style={{
            backgroundColor: "#f5be09",
            color: "#181818",
            border: "none",
            borderRadius: "5px",
            padding: "5px 10px",
            cursor: "pointer",
            margin: "10px 0",
          }}
        >
          {intl.formatMessage({ id: "close" })}
        </button>
      </div>
    </Modal>
  );
};
